<template>
<!-- 确认提示弹框 -->
  <div>
    <el-dialog
      :visible.sync="confirmTipDialog"
      :modal-append-to-body="false"
      width="380px"
      height="170px"
      style="margin-top:12vh;"
      class="confirm-dialog"
      :close-on-click-modal="false"
    >
      <div slot="title"></div>
      <div class="confirm-mass-wrap">
        <div class="wrap-tip"><i class="el-icon-warning icon-sty"></i></div>
        <div class="wrap-content">
          <div class="content-text">修改的内容尚未保存，确认离开此页？</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="levelconfirm" style="margin-right:20px">离开此页</el-button>
        <el-button type="primary" size="small" @click="confirmTipDialog = false">留在此页</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'confirmTipDialog',
  data() {
    return {
      confirmTipDialog: false
    }
  },
  methods: {
    // 取消事件
    levelconfirm() {
      this.confirmTipDialog = false;
      this.$emit('levelconfirm')
    },
    open() {
      this.confirmTipDialog = true;
    }
  }
}
</script>

<style lang="scss">
.confirm-dialog {
  .confirm-mass-wrap {
    .wrap-tip {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 55%;
      transform: translate(0,-20px);
      .icon-sty {
        font-size: 40px;
        transform: rotate(180deg);
        color: #1296DB;
      }
    }
    .wrap-content {
      .content-text {
        margin-bottom: 10px;
        text-align: center;
      }
      .content-num {
        color: #999999;
      }
    }
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-dialog__footer{
    text-align: center;
  }
}
</style>